import { can } from '@/general'
import transform from 'lodash/transform'
import isEqual from 'lodash/isEqual'
import isObject from 'lodash/isObject'
import type { Hierarchy } from '@/misc/custom-types'

export const setCaretToPos = (input: any, pos) => {
  input.focus()
  input.setSelectionRange(pos, pos)
}

export const getMeta = (metaName) => {
  const metas = document.getElementsByTagName('meta') as HTMLCollectionOf<HTMLMetaElement>

  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute('name') === metaName) {
      return metas[i].getAttribute('content')
    }
  }
}

export const difference = (object: any, base: any) => {
  const changes = (object: any, base: any) => {
    return transform(object, function (result: any[], value, key) {
      if (!isEqual(value, base[key])) {
        result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value
      }
    })
  }

  return changes(object, base)
}

export const modelTranslations = [
  {
    model: 'accountableEmployee',
    translation: 'verantwoordelijke',
  },
  {
    model: 'activity',
    translation: 'activiteit',
  },
  {
    model: 'activities',
    translation: 'werkzaamheden',
  },
  {
    model: 'activities_tool_link',
    translation: 'hulpmiddel',
  },
  {
    model: 'accounting_value',
    translation: 'grootboekrekening',
  },
  {
    model: 'accounting_values',
    translation: 'grootboekrekening',
  },
  {
    model: 'archive_types',
    translation: 'archieftype',
  },
  {
    model: 'cost_centre',
    translation: 'kostenplaats',
  },
  {
    model: 'ledger_account',
    translation: 'grootboekrekening',
  },
  {
    model: 'assignment',
    translation: 'opdracht',
  },
  {
    model: 'assignment_product',
    translation: 'opdracht product',
  },
  {
    model: 'contracts',
    translation: 'contract',
  },
  {
    model: 'contract',
    translation: 'contract',
  },
  {
    model: 'employee_sos_contact',
    translation: 'SOS-contactpersoon',
  },
  {
    model: 'employee_sos_contacts',
    translation: 'SOS-contactpersoon',
  },
  {
    model: 'employee_certificate',
    translation: 'Certificaat',
  },
  {
    model: 'employee_certificates',
    translation: 'Certificaat',
  },
  {
    model: 'certificate_valid_until',
    translation: 'Geldig tot',
  },
  {
    model: 'employee_contract',
    translation: 'Contract',
  },
  {
    model: 'employee_contracts',
    translation: 'contract',
  },
  {
    model: 'employee_contract_line',
    translation: 'contractregel',
  },
  {
    model: 'employee_contract_lines',
    translation: 'contractregel',
  },
  {
    model: 'file_templates',
    translation: 'export',
  },
  {
    model: 'transport',
    translation: 'transport',
  },
  {
    model: 'transport_product',
    translation: 'transport product',
  },
  {
    model: 'transport_location',
    translation: 'transport locatie',
  },
  {
    model: 'transport_locations',
    translation: 'transport locatie',
  },
  {
    model: 'transport_location_lines',
    translation: 'transport locatieregel',
  },
  {
    model: 'transport_location_line',
    translation: 'transport locatieregel',
  },
  {
    model: 'planning',
    translation: 'planning',
  },
  {
    model: 'note',
    translation: 'Notitie',
  },
  {
    model: 'notes',
    translation: 'Notities',
  },
  {
    model: 'planning_order_id',
    translation: 'order',
  },
  {
    model: 'planningOrder',
    translation: 'order',
  },
  {
    model: 'planning_order',
    translation: 'order',
  },
  {
    model: 'hiringProduct',
    translation: 'inhuur product',
  },
  {
    model: 'hiringUnit',
    translation: 'inhuur eenheid',
  },
  {
    model: 'vat_id',
    translation: 'Btw',
  },
  {
    model: 'employee',
    translation: 'medewerker',
  },
  {
    model: 'employees',
    translation: 'medewerkers',
  },
  {
    model: 'invoice',
    translation: 'factuur',
  },
  {
    model: 'invoices',
    translation: 'facturen',
  },
  {
    model: 'quotation',
    translation: 'offerte',
  },
  {
    model: 'quotations',
    translation: 'offertes',
  },
  {
    model: 'quotation_line',
    translation: 'offerteregel',
  },
  {
    model: 'quotation_lines',
    translation: 'offerteregels',
  },
  {
    model: 'quotation_line_field',
    translation: 'offerte tekstregel',
  },
  {
    model: 'quotation_line_sheet',
    translation: 'offerte tariefbladregel',
  },
  {
    model: 'quotation_status',
    translation: 'offertestatus',
  },
  {
    model: 'lineable',
    translation: 'regel',
  },
  {
    model: 'lineable_type',
    translation: 'regeltype',
  }
]

export const isMacintosh = function () {
  // @ts-ignore Chrome version >= 101
  if (navigator?.userAgentData?.platform) {
    // @ts-ignore
    return navigator.userAgentData.platform.toUpperCase().indexOf('MAC') >= 0
  }

  return navigator.platform.toUpperCase().indexOf('MAC') >= 0
}

export const isValidJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const getArrayIndexByPropertyValue = (array, property, value) => array.findIndex((element) => element[property].toString() === value.toString())

export const genderOptions = [
  {
    id: 'male',
    label: 'Man',
  },
  {
    id: 'female',
    label: 'Vrouw',
  }
]

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
}

export const firstToUpper = (value): string => {
  if (!value) return value

  const str = value?.toString() ?? ''

  return `${str.substr(0, 1).toUpperCase()}${str.substr(1)}`
}

export const canModify = (id: number | null, model: string): boolean => {
  return can(id ? `update ${model}` : `create ${model}`)
}

export const defaultHierarchy: Hierarchy[] = [
  {
    sequence: 0,
    value: 'material',
    description: 'Materieel'
  },
  {
    sequence: 1,
    value: 'product',
    description: 'Product'
  },
  {
    sequence: 2,
    value: 'employee',
    description: 'Medewerker'
  }
]
